<template>
    <div id="app" data-app>
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = "Senec - SmartCity";
                // document.title = to.meta.title || "SmartCity"
            }
        }
    },
    data() {
        return {
            layout: "div"
        };
    }
};
</script>
